<div class='modal-content primary-bg-color primary-text-color text-center'>
  <div #modalTitle *ngIf="title" class='modal-header secondary-bg-color secondary-text-color' [ngClass]="headerBackgroundClass">
    <button class='close' id="confirmation-modal-close-btn" (click)='hideModal()'
            [attr.aria-label]="'component.confirmation_modal.close' | translate"
            aria-describedby="modal-title"
    >
      <span aria-hidden='true'>&times;</span>
    </button>
    <h2 id="modal-title" class='modal-title' [innerHTML]="title"></h2>
  </div>
  <div class="modal-body">
    <div *ngIf="!!mainContent" class="main-content" role="region" [attr.aria-label]="title ? title + ' content' : 'Modal content'">
        <div *ngIf="!textOnly" [ngClass]="{'no-list-style':hideListStyle}" [innerHTML]="mainContent"></div>
        <div *ngIf="textOnly" class="fw-500">{{mainContent}}</div>
    </div>

    <div *ngIf="hasSubmitBtn || hasDismissBtn" class="modal-buttons">
      <ng-container *ngIf="reverseButtons">
        <button *ngIf="hasSubmitBtn"
                ftsAsyncButton
                [subscription]='loadingSubscription'
                (click)="handleSubmit()"
                class="btn font-secondary action-btn primary-bg-color primary-text-color">
          {{submitBtnTitle}}
        </button>
        <button *ngIf="hasDismissBtn"
                class="btn font-secondary dismiss-btn secondary-bg-color secondary-text-color"
                (click)='handleDismiss()'>
          {{dismissBtnTitle}}
        </button>
      </ng-container>

      <ng-container *ngIf="!reverseButtons">
        <button *ngIf="hasDismissBtn"
                class="btn font-secondary dismiss-btn primary-bg-color primary-text-color"
                (click)='handleDismiss()'>
          {{dismissBtnTitle}}
        </button>
        <button *ngIf="hasSubmitBtn"
                ftsAsyncButton
                [subscription]='loadingSubscription'
                (click)="handleSubmit()"
                class="btn font-secondary action-btn secondary-bg-color secondary-text-color">
          {{submitBtnTitle}}
        </button>
      </ng-container>
    </div>

  </div>
</div>
